import React from 'react'

const BackgroundGuides = () => {
  return (
    <div>BackgroundGuides</div>
  )
}

export default BackgroundGuides